var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons set"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 16.1545C11.336 16.1545 11 15.8185 11 15.4045V8.07751C11 7.66351 11.336 7.32751 11.75 7.32751C12.164 7.32751 12.5 7.66351 12.5 8.07751V15.4045C12.5 15.8185 12.164 16.1545 11.75 16.1545Z",
    fill: "#114DF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.417 12.4905H8.08398C7.66898 12.4905 7.33398 12.1545 7.33398 11.7405C7.33398 11.3265 7.66898 10.9905 8.08398 10.9905H15.417C15.831 10.9905 16.167 11.3265 16.167 11.7405C16.167 12.1545 15.831 12.4905 15.417 12.4905Z",
    fill: "#114DF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.064 2.50024C4.292 2.50024 2.5 4.39724 2.5 7.33524V16.1652C2.5 19.1032 4.292 21.0002 7.064 21.0002H16.436C19.209 21.0002 21 19.1032 21 16.1652V7.33524C21 4.39724 19.209 2.50024 16.436 2.50024H7.064ZM16.436 22.5002H7.064C3.437 22.5002 1 19.9542 1 16.1652V7.33524C1 3.54624 3.437 1.00024 7.064 1.00024H16.436C20.063 1.00024 22.5 3.54624 22.5 7.33524V16.1652C22.5 19.9542 20.063 22.5002 16.436 22.5002Z",
    fill: "#114DF2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.f1112f22dc33c5381aba20fad081403c.svg";
export { ForwardRef as ReactComponent };